import { useMutation, useQueryClient } from '@tanstack/react-query'
import { blockKemCard } from '../walletServices'

export const useBlockKemCard = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: blockKemCard,
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['kem-card-details'] })
      queryClient.invalidateQueries({ queryKey: ['wallet'] })
    },
  })
}
